import * as React from 'react';
import { Row, Col } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { observer } from 'mobx-react';
import { DownloadFilesTable } from './DownloadFilesTable';
import { LedIndicators } from './LedIndicators';
import { fileDownloadStore } from './FileDownloadStore';

interface DownloadOverviewProps extends WithTranslation {
  onNext: () => void;
  onDone: () => void;
}

export const DownloadOverview = withTranslation(I18N_NS.PROJECT)(observer(
  class extends React.Component<DownloadOverviewProps> {

    render() {
      const { onNext, onDone } = this.props;
      return (
        <div className="upload-modal-body">
          <Row className="mb-2 mt-1" gutter={10}>
            <Col md={15} />
            <Col md={9}>
              <LedIndicators options={fileDownloadStore.ledOptions} />
            </Col>
          </Row>
          <DownloadFilesTable onNext={onNext} onDone={onDone} />
        </div>
      );
    }
  }
));